"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subtitle_1 = require("./Subtitle");
exports.Subtitle = Subtitle_1.default;
var subtitleOptions_1 = require("./subtitleOptions");
exports.subtitleOptions = subtitleOptions_1.default;
//# sourceMappingURL=index.js.map